import React, { useEffect, useState } from "react";
import { useItems } from "../../contains/ItemContext";
import SectionSliderPostsProjects from "../../components/Sections/SectionSliderPosts_Projects";


const Projects = () => {
 const items =[
    {
      id:'1',
      title:'English Pronunciation Coach',
      subtitle:'Agentic Real Time Voice App',
      featuredImage:'/images/Eng_Coach.jpg'
    },
        {
      id:'7',
      title:'AI+ML News + Paper Summarizer',
      subtitle:'Using Facebook BART and Google FLAN',
      featuredImage:'/images/Re_Summarizer.jpg'
    },
       {
      id:'8',
      title:'Obesity Predicting ML App',
      subtitle:'Model trained with XgBoost',
      featuredImage:'/images/Ob_Predictor.jpg'
    },
       {
      id:'10',
      title:'Shilpa Learning Assistant',
      subtitle:'MCP using RAG Framework Question Answering',
      featuredImage:'/images/Learning.jpg'
    },
           {
      id:'11',
      title:'Whatsapp chat summarizer',
      subtitle:'Summarize messages from Whatsapp',
      featuredImage:'/images/Whatsapp.jpg'
    },
               {
      id:'12',
      title:'Kids Youtube Recommender',
      subtitle:'Based on Age, Interest recommend youtube channels',
      featuredImage:'/images/Youtube.jpg'
    },
                   {
      id:'13',
      title:'Personalized Welness Planner',
      subtitle:'Based on my health Proposes diet, exercise',
      featuredImage:'/images/welness.jpg'
    },
      {
      id:'9',
      title:'AI Powered Math Story Generator',
      subtitle:'LangGraph and LangChain based Kids Story Generator',
      featuredImage:'/images/Math_Story.jpg'
    },
    {
      id:'2',
      title:'Shilpa Profile',
      subtitle:'Tried Innovative way to showcase my profile',
      featuredImage:'/images/Project2.png'
    },
    {
      id:'3',
      title:'Shree Nandi Interiors',
      subtitle:'Developed from scratch and used AWS end to end solution',
      featuredImage:'/images/Project3.png'
    },
    {
      id:'4',
      title:'BioInquiries',
      subtitle:'Used React and Bootstrap for end to end development',
      featuredImage:'/images/Project4.png'
    },
    {
      id:'5',
      title:'Resume',
      subtitle:'Developed Resume using HTML and CSS',
      featuredImage:'/images/Project5.png'
    }
  ];  
  return (
    <div className={`nc-Repositories `}>
      <div className="w-full">
        <div className="container -mt-10 lg:-mt-16">
        <SectionSliderPostsProjects
          className="py-16 lg:py-28"
          postCardName="card9"
          heading="My Projects"
          subHeading="Different Tech Stack | Various Environment | Multiple Domains"
          posts={items}
        />              </div>
              </div>
    </div>
  );
};

export default Projects;
